import type { KeyboardLayout } from '@/graphql/graphql';

export const OPTIONS = {
  keyboardLayout: {
    settings: {
      editable: false,
    },
  },
  locale: {
    settings: {
      shown: false,
      editable: false,
    },
  },
};

export const LOCALES = ['nl'] as ReadonlyArray<Locale>;

export const KEYBOARD_LAYOUTS = [
  'QWERTY',
  'AZERTY',
] as ReadonlyArray<KeyboardLayout>;
